import React from "react";
import {
  CModal,
  CCard,
  CCardBody,
  CButton,
} from "@coreui/react";

const DeleteConfirmationModal = ({ visible, onClose, onConfirm, itemName }) => {
  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CCard className="m-0">
        <CCardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 text-danger">Delete Confirmation</h5>
            <CButton color="light" className="p-0" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </CButton>
          </div>

          <p>
            Are you sure you want to delete{" "}
            <strong className="text-danger">{itemName}</strong>?
            This action cannot be undone.
          </p>

          <div className="d-flex justify-content-end mt-4">
            <CButton color="danger" className="me-2" onClick={onConfirm}>
              Yes, Delete
            </CButton>
            <CButton color="secondary" onClick={onClose}>
              Cancel
            </CButton>
          </div>
        </CCardBody>
      </CCard>
    </CModal>
  );
};

export default DeleteConfirmationModal;
